import { render, staticRenderFns } from "./Brightcove.vue?vue&type=template&id=bfa09fd4&scoped=true&"
import script from "./Brightcove.vue?vue&type=script&lang=js&"
export * from "./Brightcove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa09fd4",
  null
  
)

export default component.exports